import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';

import { SubmissionSchedulerTable } from './table';

export function SubmissionScheduler() {
	return (
		<>
			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Submission Scheduler</CardTitle>
					</span>
				</CardHeader>
				<CardContent className="space-y-2">
					<SubmissionSchedulerTable />
				</CardContent>
			</Card>
		</>
	);
}
